import { Check, ChevronRight } from 'lucide-react';
import { LocationLink } from 'components/LocationLink';
import { choiceBtnUnselected } from 'components/Profile/helper';
import { CARD, CARD_EMPTY, CARD_HEADER, CARD_TITLE } from 'components/Dashboard/helper';
import Row from './Row';
import { ATTENTION_ROWS, BADGE, BADGE_COLORS, getRows } from './helper';

const OUTLINE_BTN = `btn h-10 min-h-0 gap-1 rounded-xl px-4 text-[13px] font-semibold ${choiceBtnUnselected}`;

const NeedsAttention = ({ items = [], onConfirm }) => {
  const rows = getRows(items);

  return (
    <div className={`${CARD} shrink-0 overflow-hidden`}>
      <div className={CARD_HEADER}>
        <p className={CARD_TITLE}>Needs attention</p>
        {rows.length > 0 && <span className={`${BADGE} ${BADGE_COLORS.amber}`}>{rows.length} to do</span>}
        <p className="ml-auto hidden text-xs text-secondary-500 md:block">Everything to do before your next visit, in one place</p>
      </div>

      {rows.length === 0 ? (
        <p className={CARD_EMPTY}>You&apos;re all caught up. Nothing to do before your next visit.</p>
      ) : (
        <div className="divide-y divide-gray-100">
          {rows.map((item) => {
            const row = ATTENTION_ROWS[item.type];
            const progress = row.progress?.(item);

            return (
              <Row
                key={item.type}
                icon={row.icon}
                iconClass={row.iconClass}
                title={row.title(item)}
                badge={row.badge?.(item)}
                badgeColor={row.badgeColor}
                meta={row.meta(item)}
                action={
                  row.to ? (
                    <LocationLink to={row.to(item)} className={OUTLINE_BTN}>
                      {row.cta}
                      <ChevronRight size={15} />
                    </LocationLink>
                  ) : (
                    <button
                      type="button"
                      onClick={() => onConfirm(item.appointment)}
                      className="btn h-10 min-h-0 gap-1.5 rounded-xl border-none bg-secondary-900 px-5 text-[13px] font-semibold text-white hover:bg-black"
                    >
                      <Check size={15} strokeWidth={2.8} />
                      {row.cta}
                    </button>
                  )
                }
              >
                {progress && (
                  <progress className="progress progress-success mt-2 h-1.5 w-full max-w-xs" value={progress.value} max={progress.max} />
                )}
              </Row>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default NeedsAttention;
